import { render, staticRenderFns } from "./pageController.vue?vue&type=template&id=96b5f036&"
import script from "./pageController.vue?vue&type=script&lang=ts&"
export * from "./pageController.vue?vue&type=script&lang=ts&"
import style0 from "./pageController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports